import starExp from '~/assets/icons/star_exp.svg';
import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { Divider } from '~/components/ui/Divider';
import { ImgIcon } from '~/components/ui/ImgIcon';
import { useWalletIcon } from '~/hooks';
import { rage, useObservable } from '~/rage';
import { Currency, explodeNumber } from '~/shared';
import { Button } from '../../components/Button';
import { TextStroke } from '../../components/TextStroke';
import {
	StyledButtonsContainer,
	StyledContainer,
	StyledMoneyContainer,
	StyledRewardContainer,
	StyledRewardRightContainer,
} from './Dialogs.styled';

const Dialogs = () => {
	const state = useObservable(rage.dialogues.getDialogueState());

	const rubleIcon = useWalletIcon(Currency.Ruble, true);

	return (
		<StyledContainer>
			<TextStroke style={{ fontSize: 20, fontWeight: 500, color: '#FABE2C' }}>
				{state?.title}
			</TextStroke>
			<TextStroke style={{ fontSize: 18, color: '#FFFFFF', marginTop: 12 }}>
				{state?.text}
			</TextStroke>
			{state?.rewards && state.rewards.length > 0 && (
				<StyledRewardContainer>
					<TextStroke
						style={{ fontSize: 18, color: 'rgba(255, 255, 255, 0.5)' }}
					>
						Награда за выполнение:
					</TextStroke>
					<StyledRewardRightContainer>
						{[...state.rewards]
							.sort((a, b) => {
								if (a.type === 'exp' && b.type !== 'exp') return -1;
								if (a.type !== 'exp' && b.type === 'exp') return 1;
								return 0;
							})
							.map((reward) => (
								<StyledMoneyContainer key={reward.type}>
									<TextStroke
										style={{
											color: reward.type === 'exp' ? '#FFB500' : '#ffffff',
										}}
									>
										{explodeNumber(reward.amount)}
									</TextStroke>
									{reward.type === 'exp' ? (
										<ImgIcon
											icon={starExp}
											width={20}
											height={20}
											color="#FFB500"
										/>
									) : (
										<CurrencyIcon icon={rubleIcon} size="lg" />
									)}
								</StyledMoneyContainer>
							))}
					</StyledRewardRightContainer>
				</StyledRewardContainer>
			)}
			<Divider
				$direction="H"
				$color="#ffffff"
				style={{
					marginTop: state?.rewards && state.rewards.length > 0 ? 20 : 15,
					opacity: 0.1,
				}}
			/>
			<StyledButtonsContainer>
				{state?.replies.map((reply, index) => {
					const repliesCount = state.replies.length;
					const shouldSpan =
						(repliesCount === 1 && index === 0) ||
						(repliesCount === 3 && index === 2);
					return (
						<Button
							key={reply.id}
							text={reply.text}
							type={reply.icon}
							span={shouldSpan ? 2 : undefined}
							onClick={() => {
								rage.dialogues.selectReply(reply.id);
								playSound(Sound.ClickButton);
							}}
							onMouseEnter={() => playSound(Sound.LinkCursor)}
						/>
					);
				})}
			</StyledButtonsContainer>
		</StyledContainer>
	);
};

export { Dialogs };
